import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Esto es una dieta estricta?',
  answer: 'No. Es un plan práctico para ordenar tu alimentación, no para restringirte sin sentido.'
}, {
  question: '¿Voy a tener que dejar de comer todo?',
  answer: 'No. Vas a aprender qué reemplazar y cómo seguir comiendo sin sentirte mal.'
}, {
  question: '¿Realmente voy a notar cambios en 21 días?',
  answer: 'Muchas mujeres empiezan a sentirse mejor en la primera semana y ven cambios claros antes de terminar el plan.'
}, {
  question: '¿Necesito cocinar cosas complicadas?',
  answer: 'No. Todas las recetas son simples, rápidas y pensadas para el día a día.'
}, {
  question: '¿Es solo teoría o es práctico?',
  answer: 'Es 100% práctico. Tenés menú, lista de compras, recetas y todo organizado.'
}, {
  question: '¿Qué pasa si no tengo tiempo?',
  answer: 'Justamente el plan está hecho para ahorrarte tiempo y evitar que tengas que pensar qué hacer.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Es digital. Lo descargás al instante después de comprar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const scrollToPrice = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-16 lg:py-20 bg-brand-bg-beige" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <motion.h2 className="text-3xl sm:text-4xl font-playfair font-bold text-brand-text-dark mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-33">
            Preguntas{' '}
            <span className="italic text-brand-green" data-id="element-34">frecuentes</span>
          </motion.h2>
          <div className="w-24 h-1 bg-brand-green mx-auto rounded-full" data-id="element-35"></div>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white rounded-2xl shadow-sm border border-brand-bg-cream overflow-hidden" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-37">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-38">
                <span className="font-poppins font-semibold text-brand-text-dark pr-4" data-id="element-39">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-green transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-brand-text-medium font-inter" data-id="element-43">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}